

import React from 'react';
import { IconProps } from '../../types/types';

const ImportIcon: React.FC<IconProps> = ({ size = '20', color = '#1E1E1E' }) => (
<svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.7666 5.41849L9.89994 3.28516L12.0333 5.41849" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M9.90039 11.8148V3.33984" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M3.33301 10C3.33301 13.6833 5.83301 16.6667 9.99967 16.6667C14.1663 16.6667 16.6663 13.6833 16.6663 10" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


);

export default ImportIcon;